import fs from "fs";
import http from "api";
import path from "path";

import { isObject } from "common/utils";
import { BookstoresByStateLanding } from "modules/Bookstores";
import { replaceURLWhitespace } from "modules/Bookstores/utils";

const errorHandler = (err) => {
    if (err) throw err;
};

const filePath = path.join(process.cwd(), "public/data/bookStoresData.json");

const setParamsData = (data) => {
    fs.writeFileSync(filePath, JSON.stringify(data), errorHandler);
};

const getParamsData = () => {
    const data = fs.readFileSync(filePath, errorHandler);
    const dataObj = JSON.parse(data);

    return dataObj;
};

export const getStaticPaths = async () => {
    const storesByStates = await http.getBookstoresCountByStates();

    const paths = storesByStates.map(({ state: { name } }) => ({
        params: {
            state: replaceURLWhitespace(name)
        }
    }));

    const additionalData = storesByStates.reduce((acc, { state: { name, abbreviation } }) => {
        acc[replaceURLWhitespace(name)] = { name, abbreviation };

        return acc;
    }, {});

    setParamsData(additionalData);

    return { paths, fallback: false };
};

export const getStaticProps = async (context) => {
    const {
        params: { state }
    } = context;

    const statesData = getParamsData();
    const { name, abbreviation } = statesData[state];

    const storesByState = await http.getBookstoresByState({
        params: { itemsPerPage: 200, "state.abbreviation": abbreviation }
    });

    const bookstoresByState = storesByState.map(
        ({
            name,
            website,
            phone,
            email,
            address: {
                state: { abbreviation },
                postcode,
                lines,
                city
            }
        }) => ({
            name,
            website,
            phone,
            email,
            address: {
                firstLine: Array.isArray(lines)
                    ? lines
                    : isObject(lines)
                    ? Object.values(lines)
                    : [],
                secondLine: `${city} ${abbreviation}, ${postcode}`
            }
        })
    );

    return {
        props: { stateName: name, storesByState: bookstoresByState }
    };
};

export default BookstoresByStateLanding;
